import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import { changeHighlightedProject, changeStatusProjectStatus, getAllProjects, getProjectById } from "../../../../api/project";
import { alertError, alertSuccess } from '../../../../utils/logger';
import Table, { buttonsStyle, dateFormatter } from "../../../components/tables/table";
import { buttonFormatterEditDisable } from "../../../components/tables/buttonFormatterTable";
import { getNonEmpty } from "../../../../utils/helpers";
import { registerLicense } from '@syncfusion/ej2-base';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import useGeneratePdf from "../../../../hooks/useGeneratePdf";
import TeaserTemplate from "../../../components/teaser/TeaserTemplate";

export default function ProjectsPage() {
    registerLicense("Ngo9BigBOggjHTQxAR8/V1JFaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZcc3RdQmFZVUByWkBWYEg=");

    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [refresh, setRefresh] = useState(false)
    const [project, setProject] = useState(null);
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
    const { pdfProject, isGenerating, generatePDF } = useGeneratePdf();

    useEffect(() => {
        getAllProjects()
            .then((projectsRes) => {
                const result = projectsRes.data.map(project => ({
                    title: project?.title,
                    technology: project?.technology.map(tech => getNonEmpty(tech?.id?.title)).join(", "),
                    developmentStatus: project?.developmentStatus?.title?.en,
                    status: project?.status.charAt(0).toUpperCase() + project?.status.slice(1),
                    seller: project?.seller?.fullName || '---',
                    createdAt: project.createdAt,
                    active: project.active,
                    highlighted: project?.highlighted,
                    id: project._id
                }));
                setData(result);
                setFilteredData(result);
                setRefresh(false);
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Error fetching projects.",
                });
            });
    }, [refresh]);

    function buttonFormatterHighlight(cell, data, setElem, setOpenConfirmDialog) {
        const elem = data.find((item) => item.id === cell);
        return (
            <>
                <Tooltip title={elem?.highlighted ? "Dehighlight" : "Highlighted"}>
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setElem(elem);
                            setOpenConfirmDialog(2);
                        }}
                    >
                        {elem?.highlighted ? (
                            <StarIcon style={{ color: "green" }} />
                        ) : (
                            <StarBorderIcon />
                        )}
                    </Button>
                </Tooltip>
            </>

        );
    }

    const handleDownloadTeaser = async (projectId) => {
        try {
            const projectResponse = await getProjectById(projectId);
            const project = projectResponse.data;
            generatePDF(project, project?.fakeTitle || project?.title);
        } catch (error) {
            alertError({
                error: error,
                customMessage: "Could not load project for teaser generation.",
            });
        }
    };

    function buttonFormatterTeaser(cell, data) {
        const elem = data.find((item) => item.id === cell);
        return (
            <Tooltip title="Download Teaser">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => handleDownloadTeaser(cell)}
                    disabled={isGenerating}
                >
                    <PictureAsPdfIcon />
                </Button>
            </Tooltip>
        );
    }

    const columns = [
        { dataField: "title", text: "Project name", sort: true },
        { dataField: "status", text: "Project status", sort: true },
        { dataField: "technology", text: "Technology", sort: true },
        { dataField: "developmentStatus", text: "Status", sort: true },
        { dataField: "seller", text: "Seller", sort: true },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterTeaser(cell, data),
            headerStyle: { width: '80px' }
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterHighlight(cell, data, setProject, setOpenConfirmDialog),
            headerStyle: { width: '80px' }
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisable(cell, "project", data, true, setProject, setOpenConfirmDialog, history),
            headerStyle: { width: '120px' }
        },
    ];


    return (
        <Card>
            <CardHeader title="Projects list">
                {/*<CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-project")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>*/}
            </CardHeader>
            <CardBody>
                <Table data={filteredData} columns={columns} />

                <ConfirmDialog
                    title={`Are you sure you want to ${project?.highlighted ? "dehighlight" : "highlight"} this project?`}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeHighlightedProject(project.id, !project?.highlighted)
                            .then((res) => {
                                alertSuccess({
                                    title: `${project?.highlighted ? "Dehighlight!" : "Highlighted!"
                                        }`,
                                    customMessage: `Project ${project?.highlighted ? "dehighlight" : "highlighted"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${project?.highlighted ? "highlight" : "dehighlight"
                                        } the project.`,
                                });
                            });
                    }}
                />

                <ConfirmDialog
                    title={`Are you sure you want to ${project?.active ? "deactivate" : "activate"} this project?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusProjectStatus(project.id, !project?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${project?.active ? "Deactivated!" : "Activated!"
                                        }`,
                                    customMessage: `Project ${project?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${project?.active ? "activate" : "deactivate"
                                        } the project.`,
                                });
                            });
                    }}
                />

                {isGenerating && (
                    <div id="teaser-template" style={{ display: "none" }}>
                        <TeaserTemplate project={pdfProject} />
                    </div>
                )}
            </CardBody>
        </Card>
    );
}